module.exports = __webpack_public_path__ + "img/w6.f4171cd7.png";